// Set constraints for the video stream
const constraints = { video: { facingMode: 'environment' }, audio: false };
// eslint-disable-next-line no-unused-vars
let track = null;

// Crop image to provided aspect ratio
export const crop = (url, aspectRatio) => new Promise((resolve) => {
  const inputImage = new Image();

  inputImage.onload = () => {
    const inputWidth = inputImage.naturalWidth;
    const inputHeight = inputImage.naturalHeight;
    const inputImageAspectRatio = inputWidth / inputHeight;
    let outputWidth = inputWidth;
    let outputHeight = inputHeight;

    if (inputImageAspectRatio > aspectRatio) {
      outputWidth = inputHeight * aspectRatio;
    } else if (inputImageAspectRatio < aspectRatio) {
      outputHeight = inputWidth / aspectRatio;
    }

    // calculate the position to draw the image at
    const outputX = (outputWidth - inputWidth) * 0.5;
    const outputY = (outputHeight - inputHeight) * 0.5;

    // create a canvas that will present the output image
    const outputImage = document.createElement('canvas');

    // set it to the same size as the image
    outputImage.width = outputWidth;
    outputImage.height = outputHeight;

    // draw image at position 0, 0 on the canvas
    const ctx = outputImage.getContext('2d');
    ctx.drawImage(inputImage, outputX, outputY);
    resolve(outputImage);
  };

  // start loading image
  inputImage.src = url;
});

// Access the device camera and stream to cameraView
export const cameraStart = (cameraView, cameraOutput = null) => {
  if (cameraOutput) {
    cameraOutput.classList.remove('taken');
  }

  navigator.mediaDevices
    .getUserMedia(constraints)
    .then((stream) => {
      [track] = stream.getTracks();
      cameraView.srcObject = stream;
    })
    .catch((error) => {
      throw error;
    });
};

// Take a picture when cameraTrigger is tapped
export const cameraTrigger = async (cameraView, cameraSensor, cameraOutput) => {
  cameraSensor.width = cameraView.videoWidth;
  cameraSensor.height = cameraView.videoHeight;
  cameraSensor.getContext('2d').drawImage(cameraView, 0, 0);
  cameraOutput.src = cameraSensor.toDataURL('image/png');
  cameraOutput.classList.add('taken');
  track.stop();

  const ctx = cameraSensor.getContext('2d');
  const cropped = await crop(
    cameraSensor.toDataURL('image/png'),
    16 / 9,
  );

  const imageObj = new Image();

  imageObj.src = cropped.toDataURL('image/png');

  imageObj.onload = () => {
    cameraSensor.width = imageObj.width;
    cameraSensor.height = imageObj.height;
    ctx.drawImage(imageObj, 0, 0);
  };

  return imageObj;
};

export default {
  crop,
  cameraStart,
  cameraTrigger,
};
